var map = {
	"./base/index.html": 23287,
	"./base/main.app": 12305,
	"./base/main.app.js": 12305,
	"./components/agenciesTools/NavBar": 32070,
	"./components/agenciesTools/NavBar.vue": 32070,
	"./components/pages/Home": 99984,
	"./components/pages/Home.vue": 99984,
	"./components/pages/Login": 43148,
	"./components/pages/Login.vue": 43148,
	"./components/pages/Report": 77829,
	"./components/pages/Report.vue": 77829,
	"./components/reports/HotelCostListReport": 37792,
	"./components/reports/HotelCostListReport.vue": 37792,
	"./components/reports/HotelModal": 91528,
	"./components/reports/HotelModal.vue": 91528,
	"./components/reports/ServiceCostListReport": 99674,
	"./components/reports/ServiceCostListReport.vue": 99674,
	"./components/reports/ServiceModal": 76806,
	"./components/reports/ServiceModal.vue": 76806,
	"./components/svg/BedKey": 17995,
	"./components/svg/BedKey.vue": 17995,
	"./components/svg/DayOne": 4701,
	"./components/svg/DayOne.vue": 4701,
	"./components/svg/Filters": 58965,
	"./components/svg/Filters.vue": 58965,
	"./components/svg/Icon": 30987,
	"./components/svg/Icon.vue": 30987,
	"./components/svg/ImageLink": 21991,
	"./components/svg/ImageLink.vue": 21991,
	"./components/svg/ImageSize": 60223,
	"./components/svg/ImageSize.vue": 60223,
	"./components/svg/MatBed": 46464,
	"./components/svg/MatBed.vue": 46464,
	"./components/svg/MemoInfo": 48570,
	"./components/svg/MemoInfo.vue": 48570,
	"./components/svg/MemoInfo2": 24546,
	"./components/svg/MemoInfo2.vue": 24546,
	"./components/svg/Optional": 7187,
	"./components/svg/Optional.vue": 7187,
	"./components/svg/PasteFormat": 3421,
	"./components/svg/PasteFormat.vue": 3421,
	"./components/svg/Pickup": 65047,
	"./components/svg/Pickup.vue": 65047,
	"./components/svg/Pin": 43956,
	"./components/svg/Pin.vue": 43956,
	"./components/svg/PriceCheck": 40043,
	"./components/svg/PriceCheck.vue": 40043,
	"./components/svg/Question": 19562,
	"./components/svg/Question.vue": 19562,
	"./components/svg/RecordHistory": 47963,
	"./components/svg/RecordHistory.vue": 47963,
	"./components/svg/SelectAll": 97302,
	"./components/svg/SelectAll.vue": 97302,
	"./components/svg/SglBed": 99013,
	"./components/svg/SglBed.vue": 99013,
	"./components/svg/SlashedDolar": 16508,
	"./components/svg/SlashedDolar.vue": 16508,
	"./components/svg/Speed": 86093,
	"./components/svg/Speed.vue": 86093,
	"./components/svg/SvgChangelog": 99136,
	"./components/svg/SvgChangelog.vue": 99136,
	"./components/svg/Sync": 92770,
	"./components/svg/Sync.vue": 92770,
	"./components/svg/Ticket": 30574,
	"./components/svg/Ticket.vue": 30574,
	"./components/svg/TplBed": 4288,
	"./components/svg/TplBed.vue": 4288,
	"./components/svg/TwinBed": 98688,
	"./components/svg/TwinBed.vue": 98688,
	"./components/svg/VoucherSlash": 64734,
	"./components/svg/VoucherSlash.vue": 64734,
	"./components/svg/XMark": 27693,
	"./components/svg/XMark.vue": 27693,
	"./components/svg/xmark.svg": 24355,
	"./components/tools/AccessGroupTree": 76114,
	"./components/tools/AccessGroupTree.vue": 76114,
	"./components/tools/AccessGroupTreeNode": 82968,
	"./components/tools/AccessGroupTreeNode.vue": 82968,
	"./components/tools/AlertPopup": 44870,
	"./components/tools/AlertPopup.vue": 44870,
	"./components/tools/AppNewsModal": 25363,
	"./components/tools/AppNewsModal.vue": 25363,
	"./components/tools/AsyncImg": 607,
	"./components/tools/AsyncImg.vue": 607,
	"./components/tools/Attach": 71182,
	"./components/tools/Attach.vue": 71182,
	"./components/tools/BlockUI": 50838,
	"./components/tools/BlockUI.vue": 50838,
	"./components/tools/Breadcrumb": 65186,
	"./components/tools/Breadcrumb.vue": 65186,
	"./components/tools/ColorPicker": 40248,
	"./components/tools/ColorPicker.vue": 40248,
	"./components/tools/ConfirmClose": 69703,
	"./components/tools/ConfirmClose.vue": 69703,
	"./components/tools/ConfirmDelete": 31829,
	"./components/tools/ConfirmDelete.vue": 31829,
	"./components/tools/ContextMenu": 18481,
	"./components/tools/ContextMenu.vue": 18481,
	"./components/tools/Dashboard": 59011,
	"./components/tools/Dashboard.vue": 59011,
	"./components/tools/DashboardCard": 31882,
	"./components/tools/DashboardCard.vue": 31882,
	"./components/tools/DatePicker": 37071,
	"./components/tools/DatePicker.vue": 37071,
	"./components/tools/DateSelector": 73279,
	"./components/tools/DateSelector.vue": 73279,
	"./components/tools/DateTime": 57912,
	"./components/tools/DateTime.vue": 57912,
	"./components/tools/EditedBy": 55446,
	"./components/tools/EditedBy.vue": 55446,
	"./components/tools/Escape": 84048,
	"./components/tools/Escape.vue": 84048,
	"./components/tools/GaugeChart": 34306,
	"./components/tools/GaugeChart.vue": 34306,
	"./components/tools/GoogleMap": 79455,
	"./components/tools/GoogleMap.vue": 79455,
	"./components/tools/HtmlTag": 5687,
	"./components/tools/HtmlTag.vue": 5687,
	"./components/tools/HtmlView": 7993,
	"./components/tools/HtmlView.vue": 7993,
	"./components/tools/IFrame": 56735,
	"./components/tools/IFrame.vue": 56735,
	"./components/tools/ImageNames": 38713,
	"./components/tools/ImageNames.vue": 38713,
	"./components/tools/ImageSelect": 19328,
	"./components/tools/ImageSelect.vue": 19328,
	"./components/tools/ImportExcel": 79349,
	"./components/tools/ImportExcel.vue": 79349,
	"./components/tools/InApp": 52254,
	"./components/tools/InApp.vue": 52254,
	"./components/tools/InputField": 62458,
	"./components/tools/InputField.vue": 62458,
	"./components/tools/InputNote": 21823,
	"./components/tools/InputNote.vue": 21823,
	"./components/tools/InputValue": 43315,
	"./components/tools/InputValue.vue": 43315,
	"./components/tools/JsonEditor": 73394,
	"./components/tools/JsonEditor.vue": 73394,
	"./components/tools/LanguagesComp": 71797,
	"./components/tools/LanguagesComp.vue": 71797,
	"./components/tools/LanguagesList": 3862,
	"./components/tools/LanguagesList.vue": 3862,
	"./components/tools/LinGallery": 12098,
	"./components/tools/LinGallery.vue": 12098,
	"./components/tools/Login": 9773,
	"./components/tools/Login.vue": 9773,
	"./components/tools/Logout": 43809,
	"./components/tools/Logout.vue": 43809,
	"./components/tools/MailActivity": 51913,
	"./components/tools/MailActivity.vue": 51913,
	"./components/tools/MailWindow": 29733,
	"./components/tools/MailWindow.vue": 29733,
	"./components/tools/NavBar": 37352,
	"./components/tools/NavBar.vue": 37352,
	"./components/tools/Notification": 8767,
	"./components/tools/Notification.vue": 8767,
	"./components/tools/NotificationModal": 9064,
	"./components/tools/NotificationModal.vue": 9064,
	"./components/tools/NumberInput": 33197,
	"./components/tools/NumberInput.vue": 33197,
	"./components/tools/PaymentsHelp": 45605,
	"./components/tools/PaymentsHelp.vue": 45605,
	"./components/tools/Photo": 47239,
	"./components/tools/Photo.vue": 47239,
	"./components/tools/PhotoCroppa": 17770,
	"./components/tools/PhotoCroppa.vue": 17770,
	"./components/tools/PhotoGallery": 97266,
	"./components/tools/PhotoGallery.vue": 97266,
	"./components/tools/PhotoPicker": 8475,
	"./components/tools/PhotoPicker.vue": 8475,
	"./components/tools/PhotoSlider": 58501,
	"./components/tools/PhotoSlider.vue": 58501,
	"./components/tools/PhotoSmall": 10278,
	"./components/tools/PhotoSmall.vue": 10278,
	"./components/tools/RecordImageRows": 96310,
	"./components/tools/RecordImageRows.vue": 96310,
	"./components/tools/RecordWeekDays": 33956,
	"./components/tools/RecordWeekDays.vue": 33956,
	"./components/tools/RecordWindow": 11731,
	"./components/tools/RecordWindow.vue": 11731,
	"./components/tools/RecordWindowModal": 83510,
	"./components/tools/RecordWindowModal.vue": 83510,
	"./components/tools/RecordWindowRow": 72564,
	"./components/tools/RecordWindowRow.vue": 72564,
	"./components/tools/ReportFiltersConfig": 98434,
	"./components/tools/ReportFiltersConfig.vue": 98434,
	"./components/tools/ReportLabels": 60545,
	"./components/tools/ReportLabels.vue": 60545,
	"./components/tools/ReportTask": 9042,
	"./components/tools/ReportTask.vue": 9042,
	"./components/tools/ReportWindow": 90687,
	"./components/tools/ReportWindow.vue": 90687,
	"./components/tools/RowInputField": 32328,
	"./components/tools/RowInputField.vue": 32328,
	"./components/tools/ScrollUp": 75678,
	"./components/tools/ScrollUp.vue": 75678,
	"./components/tools/SearchBox": 70941,
	"./components/tools/SearchBox.vue": 70941,
	"./components/tools/SelectInput": 72882,
	"./components/tools/SelectInput.vue": 72882,
	"./components/tools/SelectValue": 74857,
	"./components/tools/SelectValue.vue": 74857,
	"./components/tools/SideBar": 14602,
	"./components/tools/SideBar.vue": 14602,
	"./components/tools/Support": 71597,
	"./components/tools/Support.vue": 71597,
	"./components/tools/TableEditor": 41448,
	"./components/tools/TableEditor.vue": 41448,
	"./components/tools/TableMixin": 9339,
	"./components/tools/TableMixin.vue": 9339,
	"./components/tools/TableSelector": 7365,
	"./components/tools/TableSelector.vue": 7365,
	"./components/tools/TextAreaEditStyle": 30526,
	"./components/tools/TextAreaEditStyle.vue": 30526,
	"./components/tools/TextAreaStyle": 66453,
	"./components/tools/TextAreaStyle-old": 55089,
	"./components/tools/TextAreaStyle-old.vue": 55089,
	"./components/tools/TextAreaStyle.vue": 66453,
	"./components/tools/TextRows": 51928,
	"./components/tools/TextRows.vue": 51928,
	"./components/tools/TextRowsStyle": 74054,
	"./components/tools/TextRowsStyle.vue": 74054,
	"./components/tools/VueMenuItem": 7438,
	"./components/tools/VueMenuItem.vue": 7438,
	"./components/tools/VueSelect": 21071,
	"./components/tools/VueSelect.vue": 21071,
	"./components/tools/YesNot": 4560,
	"./components/tools/YesNot.vue": 4560,
	"./components/tools/abm": 5791,
	"./components/tools/abm.vue": 5791,
	"./components/tools/abmBooking": 31598,
	"./components/tools/abmBooking.vue": 31598,
	"./css/agencies.scss": 79521,
	"./css/app.scss": 63789,
	"./css/bootstrap-datepicker3.min.css": 70324,
	"./css/bootstrap-grid.min.css": 70101,
	"./css/bootstrap.min.css": 55086,
	"./css/confirmation.scss": 11787,
	"./css/cookieconsent.css": 88182,
	"./css/dragula.min.css": 19590,
	"./css/nunito.css": 42035,
	"./css/quill.scss": 94287,
	"./css/r-style.scss": 628,
	"./css/remixicon/remixicon.css": 53368,
	"./css/remixicon/remixicon.eot": 11406,
	"./css/remixicon/remixicon.less": 30645,
	"./css/remixicon/remixicon.svg": 64431,
	"./css/remixicon/remixicon.symbol.svg": 24719,
	"./css/remixicon/remixicon.ttf": 93368,
	"./css/remixicon/remixicon.woff": 71768,
	"./css/remixicon/remixicon.woff2": 96906,
	"./css/style.scss": 67051,
	"./css/voucher.scss": 11872,
	"./extra/custom/components/reports/HotelCostListReport": 69921,
	"./extra/custom/components/reports/HotelCostListReport.vue": 69921,
	"./extra/custom/components/reports/ServiceCostListReport": 57125,
	"./extra/custom/components/reports/ServiceCostListReport.vue": 57125,
	"./extra/custom/css/constants.scss": 3378,
	"./extra/custom/img/Htl_Verdes.png": 91658,
	"./extra/custom/img/favicon.ico": 10492,
	"./extra/custom/img/logo-full.png": 60183,
	"./extra/custom/img/logo-full.svg": 73080,
	"./extra/custom/img/logo-itinerary.png": 24189,
	"./extra/custom/img/logo-voucher.png": 84680,
	"./extra/custom/img/logo-voucher.svg": 48487,
	"./extra/custom/img/logo-white.png": 53529,
	"./extra/custom/img/logo-white.svg": 41486,
	"./extra/custom/img/logo.png": 85469,
	"./extra/custom/img/logo.svg": 37186,
	"./img/LOGO_01.png": 64980,
	"./img/LOGO_NUBBO.png": 25431,
	"./img/LOGO_NUBBO_FINAL-02.png": 53975,
	"./img/LOGO_NUBBO_FINAL-12.png": 50024,
	"./img/bed-key.svg": 9849,
	"./img/day_one.svg": 10189,
	"./img/dolar_slash.svg": 55220,
	"./img/expenses.svg": 30545,
	"./img/loading.gif": 79906,
	"./img/location-pin-solid.svg": 69999,
	"./img/memo_info.svg": 59455,
	"./img/spin.png": 27721,
	"./languages/countries/de/world": 63966,
	"./languages/countries/de/world.json": 63966,
	"./languages/countries/en/world": 62730,
	"./languages/countries/en/world.json": 62730,
	"./languages/countries/es/world": 67537,
	"./languages/countries/es/world.json": 67537,
	"./languages/countries/fr/world": 56057,
	"./languages/countries/fr/world.json": 56057,
	"./languages/countries/it/world": 99708,
	"./languages/countries/it/world.json": 99708,
	"./languages/countries/nl/world": 61163,
	"./languages/countries/nl/world.json": 61163,
	"./languages/countries/pt/world": 52309,
	"./languages/countries/pt/world.json": 52309,
	"./languages/de": 72842,
	"./languages/de.json": 72842,
	"./languages/en": 70786,
	"./languages/en.json": 70786,
	"./languages/es": 39777,
	"./languages/es.json": 39777,
	"./languages/fr": 53577,
	"./languages/fr.json": 53577,
	"./languages/it": 65028,
	"./languages/it.json": 65028,
	"./languages/nl": 53011,
	"./languages/nl.json": 53011,
	"./languages/pt": 48857,
	"./languages/pt.json": 48857,
	"./languages/system_languages": 71040,
	"./languages/system_languages.json": 71040,
	"./quill/quill": 5706,
	"./quill/quill.1.3": 76980,
	"./quill/quill.1.3.js": 76980,
	"./quill/quill.js": 5706,
	"./quill/quill.min": 64868,
	"./quill/quill.min.js": 64868,
	"./quill/quill.show.css": 70038,
	"./quill/quill.snow.1.3.css": 77066,
	"./quill/quill.snow.2.css": 2460,
	"./quill/quill.snow.css": 91328,
	"./router/": 58197,
	"./router/index": 58197,
	"./router/index.js": 58197,
	"./store/booking": 76514,
	"./store/booking.js": 76514,
	"./store/main": 40688,
	"./store/main.js": 40688,
	"./store/quill": 6516,
	"./store/quill.js": 6516,
	"./store/store": 41544,
	"./store/store.js": 41544,
	"./tools/BarChart": 66778,
	"./tools/BarChart.js": 66778,
	"./tools/PieChart": 90491,
	"./tools/PieChart.js": 90491,
	"./tools/cookieconsent": 51769,
	"./tools/cookieconsent.js": 51769,
	"./tools/docx": 76479,
	"./tools/docx.js": 76479,
	"./tools/event-bus": 53226,
	"./tools/event-bus.js": 53226,
	"./tools/front-tools": 5172,
	"./tools/front-tools.js": 5172,
	"./tools/gmaps": 57127,
	"./tools/gmaps.js": 57127,
	"./tools/icons": 73399,
	"./tools/icons.js": 73399,
	"./tools/load-tables": 78167,
	"./tools/load-tables.js": 78167,
	"./tools/logsErrors": 3393,
	"./tools/logsErrors.js": 3393,
	"./tools/modules": 23088,
	"./tools/modules.js": 23088,
	"./tools/notifications": 94525,
	"./tools/notifications.js": 94525,
	"./tools/oms.min": 93690,
	"./tools/oms.min.js": 93690,
	"./tools/table2CSV": 47095,
	"./tools/table2CSV.js": 47095,
	"./tools/vue-tools": 72255,
	"./tools/vue-tools.js": 72255
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66729;